import React from 'react';
import { useSelector } from 'react-redux';

import { TemplateSearchEmptyState } from 'js/src/components/app/template-preview/TemplateSearchEmptyState';
import TemplatePreviewButton from 'js/src/components/common/ui/TemplatePreviewButton';
import { getAllFilteredTemplateIds, getTemplateSearchQuery } from 'js/src/data/templates';
import type { RootState } from 'js/src/libs/RootState';
import type { StoredTemplate } from 'js/src/data/templates';

type TemplateSearchResultsListProps = {
    onTemplateClick: (template: StoredTemplate) => void;
    selectedTemplateId?: string;
    hidePreviewButton?: boolean;
};

const TemplateSearchResultsList = React.memo(function TemplateSearchResultsList({
    onTemplateClick,
    selectedTemplateId,
    hidePreviewButton,
}: TemplateSearchResultsListProps) {
    const allFilteredTemplateIds = useSelector((state: RootState) =>
        getAllFilteredTemplateIds(state),
    );
    const searchQuery = useSelector((state: RootState) => getTemplateSearchQuery(state));

    if (allFilteredTemplateIds.length === 0) {
        return <TemplateSearchEmptyState searchQuery={searchQuery} />;
    }

    return (
        <div className="template-grid">
            {allFilteredTemplateIds.map((templateId) => (
                <TemplatePreviewButton
                    onClick={onTemplateClick}
                    templateId={templateId}
                    selected={selectedTemplateId === templateId}
                    hidePreviewButton={hidePreviewButton}
                    key={templateId}
                />
            ))}
        </div>
    );
});

export default TemplateSearchResultsList;
